declare let THREE: any;

export class ScaleDot extends (THREE.Mesh as { new(geometry, material): any; }) {

  constructor(directions: Array<any>, size) {
    const rot = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));
    const geometry = new THREE.PlaneBufferGeometry(size, size).applyMatrix(rot);
    const material = new THREE.MeshBasicMaterial({
      color: 0x000000,
      side: THREE.DoubleSide
    });
    super(geometry, material);
    this.userData.directions = directions;
    this.name = 'dot';
  }

  get directions(): Array<any> {
    return this.userData.directions;
  }

  get direction() {
    return this.directions.reduce((result, current) => result.add(current), new THREE.Vector3(0, 0, 0));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/ScaleDot.ts